var map = {
	"./PubBtn.vue": "As8n",
	"./PubTextBtn.vue": "ZXF7",
	"./SvgIcon.vue": "tj1S"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2AA3";


//////////////////
// WEBPACK FOOTER
// ./src/components/Base nonrecursive [A-Z]\w+\.(vue|js)$
// module id = 2AA3
// module chunks = 8